var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"br2-l ba b--black-10 pv4 mv2 mv3-l w-100 w-60-m w-35-l mw6 center bg-white items-center flex flex-column justify-center"},[_c('spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }